/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Emailnote1Inputs */

const he_profile_emailnote1 = /** @type {(inputs: Profile_Emailnote1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא ניתן לשנות את האימייל.`)
};

const en_profile_emailnote1 = /** @type {(inputs: Profile_Emailnote1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email cannot be changed.`)
};

/**
* | output |
* | --- |
* | "Email cannot be changed." |
*
* @param {Profile_Emailnote1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_emailnote1 = /** @type {((inputs?: Profile_Emailnote1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Emailnote1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_emailnote1(inputs)
	return en_profile_emailnote1(inputs)
});
export { profile_emailnote1 as "profile_emailNote" }